var map = {
	"./219423.png": 694,
	"./402593.png": 3740,
	"./402593.svg": 3342,
	"./846338.png": 2959,
	"./846338.svg": 1569,
	"./Delarship1.png": 2442,
	"./Delarship1.svg": 4188,
	"./add-corporate.png": 3568,
	"./branch-management.png": 6175,
	"./businessman-1.svg": 6663,
	"./businessman.svg": 7157,
	"./calendar-1.svg": 3733,
	"./calendar.png": 3129,
	"./calendar.svg": 2659,
	"./charger-management.png": 5281,
	"./charging_station.svg": 7741,
	"./cop1.svg": 7366,
	"./cop12.png": 2956,
	"./corporate-1.svg": 2532,
	"./corporate.png": 8102,
	"./corporate.svg": 8382,
	"./dash1.svg": 2526,
	"./dashboard.jpg": 2287,
	"./deal1.png": 1340,
	"./deal12.svg": 2454,
	"./dealer-5.svg": 5004,
	"./dealers.png": 9921,
	"./dealers.svg": 4781,
	"./discount.png": 8594,
	"./discount.svg": 172,
	"./document.png": 9800,
	"./document.svg": 1050,
	"./electric-station.svg": 8423,
	"./human.svg": 1680,
	"./info.svg": 8189,
	"./managerUser.svg": 4599,
	"./not-1.1.svg": 9321,
	"./not-1.png": 9030,
	"./not-2.1.svg": 3550,
	"./not-2.png": 6589,
	"./notsvg1.svg": 8595,
	"./plug.svg": 7649,
	"./support.svg": 2514,
	"./tariffIcon.png": 7250,
	"./user.png": 7618,
	"./user.svg": 7416,
	"./video_icon.svg": 8854,
	"./wallet.png": 9796,
	"./wallet.svg": 5594
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4163;